import React from 'react'
import styles from './influencerSec.module.css'
import { Images } from 'lucide-react'
import { InfluencerBoostImg, InfluencerBoostImgNew } from '../../../assets'
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import useTextAnimation from "../../hooks/useTextAnimation.js";
import i18n from '../../../i18n.js';
import { LANG_AR } from '../../helpers/constant.jsx';
import { useTranslation } from 'react-i18next';

const InfluencerFirstSec = ({ configData }) => {
    const { ref: headingRef, inView: headingInView, textAnimation } = useTextAnimation();
    const { ref: paragraphRef, inView: paragraphInView } = useTextAnimation();
    const [t, i18n]= useTranslation()
    return (
        <div className={styles.influencerBoost}>
            <div className={`${styles.influencerBoostInner} ${i18n.language===LANG_AR? 'arab':''} ${styles.influencerBoostInnerTop}`}>
                <div className={`${styles.influencerBoostTxt} ${i18n.language===LANG_AR? 'arabText':''}`}>
                    <motion.h3
                        ref={headingRef}
                        initial="hidden"
                        animate={headingInView ? "visible" : "hidden"}
                        custom={0}
                        variants={textAnimation}
                        dangerouslySetInnerHTML={{ __html: `${t('partner')}<br />
                                ${t('ourInfluencer')}<br />
                                ${t('transform')}<br />
                                ${t('brand')}<br />
                                ${t('movement')}` }}
                        >{/* {t('partner')}<br />
                            {t('ourInfluencer')}<br /> {t('transform')} <br />
                            {t('brand')} <br />
                            {t('movement')} */}
                    </motion.h3>
                    {/* <motion.p
                        ref={paragraphRef}
                        initial="hidden"
                        animate={paragraphInView ? "visible" : "hidden"}
                        custom={1}
                        variants={textAnimation}
                        dangerouslySetInnerHTML={{ __html: configData.infDescription }}
                    ></motion.p> */}
                </div>
                <div className={styles.influencerBoostImg}>
                    <img src={InfluencerBoostImg} alt="" />
                </div>
            </div>
        </div>
    )
}

export default InfluencerFirstSec
